export default __webpack_public_path__ + "static/media/filgreen2.e35e67ae.png";